import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from "../custom-error-handler.service";
import { GeoIpException } from "../../../models/geo-ip-exception/geo-ip-exception.model";
import { GeoIpExceptionSerializer } from "../../../models/geo-ip-exception/geo-ip-exception-serializer.class";

/**
 * Service to communicate with API Client Users
 */

@Injectable()
export class GeoIpExceptionsService extends BaseApiService<GeoIpException> {
  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      null,
      "geo/exceptions",
      new GeoIpExceptionSerializer(),
      new CustomErrorHandlerService()
    );
  }

  // EXTEND/OVERRIDE THE SERVICE HERE IF NECESSARY
}
